<div class="container-fluid">
    <div class="col-8 offset-2">
        <h2 style="text-align: center;">Connexion au service</h2>
    </div>
</div>